import GroupTopicsRoute from "discourse/routes/group/activity/topics";
import { i18n } from "discourse-i18n";

export default class CircleActivityTopicsRoute extends GroupTopicsRoute {
  titleToken() {
    const filterText = i18n("filters.latest.title");

    return i18n("filters.with_category", {
      category: this.modelFor("circle").name,
      filter: filterText,
    });
  }

  async model() {
    const circleModel = this.modelFor("circle");

    if (circleModel.can_read_topics) {
      const topicList = await this.store.findFiltered("topicList", {
        filter: circleModel.slug
          ? `c/${circleModel.slug}/${circleModel.category_id}/l/latest`
          : `c/${circleModel.category_id}/l/latest`,
        params: {
          ascending: false,
          circles_no_definitions: true,
        },
      });

      // in case the topics are doing something fancy because they belong to a
      // circle
      const basicCircle = topicList?.topics?.[0];
      topicList?.topics?.forEach((topic) => (topic.circle = basicCircle));

      return topicList;
    }

    return null;
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    controller.circleModel = this.modelFor("circle");
  }
}
